import axiosInstance from "../utils/axios";
import { normalizeOperatingHours } from "../utils/CampusBuildingsUtil";

/**
 * Returns detail for a Campus.
 */
export const GetCampusDetails = async (campusId, cancelToken) => {
    return await axiosInstance().get(`/getCampusDetails`, {
        params: { campusId },
        cancelToken
    });
};

export const GetCampusBuildingsList = async (campusId, params = {}, cancelToken = null) => {
    const config = {
        params: { campusId, ...params }
    };
    if (cancelToken) config.cancelToken = cancelToken;
    return await axiosInstance().get(`/getCampusBuildingsList`, config);
};

export const GetCampusBuildingRoomsList = async (campusId, params = {}, cancelToken = null) => {
    const config = {
        params: { campusId, ...params }
    };
    if (cancelToken) {
        config.cancelToken = cancelToken;
    }
    return await axiosInstance().get(`/getCampusBuildingRoomsList`, config);
};

export const PutSaveCampusDetail = async (campusId, campusDetail, cancelToken) => {
    const payload = {
        campusId: Number(campusId),
        ...campusDetail
    };
    return await axiosInstance().put('/putSaveCampusDetail', payload, { cancelToken });
};

export const PutSaveCampusBuilding = async (buildingData, campusId, cancelToken) => {
    const formData = new FormData();
    formData.append("id", buildingData.id);
    formData.append("name", buildingData.name);
    formData.append("open_time", buildingData.open_time);
    formData.append("close_time", buildingData.close_time);
    formData.append("grouping_color", buildingData.grouping_color);
    formData.append("campus_id", campusId);
    formData.append("netsuite_id", buildingData.netsuite_id);
    formData.append("operating_hours", JSON.stringify(
        normalizeOperatingHours(buildingData.operating_hours)
    ));

    // Optional fields
    if (buildingData.map_image && buildingData.map_image instanceof File) {
        formData.append("mapImage", buildingData.map_image);
    }

    return await axiosInstance().put('/putSaveCampusBuilding', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        cancelToken
    });
};

export const PutSaveCampusBuildingRoom = async (roomData, cancelToken) => {
    const payload = {
        ...roomData,
        operating_hours: normalizeOperatingHours(roomData.operating_hours)
    };
    return await axiosInstance().put('/putSaveCampusBuildingRoom', payload, { cancelToken });
};

export const PostSaveCampusBuilding = async (buildingData, campusId, cancelToken) => {
    const formData = new FormData();
    formData.append("name", buildingData.name);
    formData.append("open_time", buildingData.open_time);
    formData.append("close_time", buildingData.close_time);
    formData.append("grouping_color", buildingData.grouping_color);
    formData.append("campus_id", campusId);
    formData.append("netsuite_id", buildingData.netsuite_id);
    formData.append("operating_hours", JSON.stringify(
        normalizeOperatingHours(buildingData.operating_hours)
    ));

    // Optional fields
    if (buildingData.map_image && buildingData.map_image instanceof File) {
        formData.append("mapImage", buildingData.map_image);
    }

    return await axiosInstance().post('/postSaveCampusBuilding', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        cancelToken
    });
};

export const PostSaveCampusBuildingRoom = async (roomData, cancelToken) => {
    const payload = {
        ...roomData,
        operating_hours: normalizeOperatingHours(roomData.operating_hours)
    };
    return await axiosInstance().post('/postSaveCampusBuildingRoom', payload, { cancelToken });
};

export const DeleteCampusBuilding = async (buildingId, cancelToken) => {
    return await axiosInstance().delete('/deleteCampusBuilding', {
        data: { buildingId },
        cancelToken
    });
};

export const DeleteCampusBuildingRooms = async (roomId, cancelToken) => {
    return await axiosInstance().delete('/deleteCampusBuildingRooms', {
        data: { roomId },
        cancelToken
    });
};
